<template>
  <div class="bulletin-container " :class="{'fill-page-container':unIframe}">
    <a-tabs :default-active-key="activeKey" :active-key="acKey" hide-add type="card" @tabClick="handleChange">
      <a-tab-pane key="list" tab="内容列表">
        <NewsList ref="newsList" />
      </a-tab-pane>
      <a-tab-pane key="config" tab="内容配置">
        <ContentConfig ref="contentConfig" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import NewsList from '@/pages/bulletin/components/NewsList.vue'
import ContentConfig from '@/pages/bulletin/components/ContentConfig.vue'

export default {
  name: 'BulletinIndex',
  components: {
    NewsList,
    ContentConfig
  },
  data() {
    return {
      activeKey: 'list',
      acKey: 'list',
      pathObj: {
        list: 'newsList',
        config: 'contentConfig'
      }
    }
  },
  computed: {
    unIframe() {
      
      return  window.self === window.top
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      console.log('to', to)
      vm.activeKey = to.path.includes('contentConfig') ?  'config':'list' 
      vm.acKey = vm.activeKey
      if (to.params.reload) {
        vm.handleSearch()
      }
    })
  },
  created() {
    if( this.$route.path.includes('bulletinManagement')){
      this. pathObj={
        list: 'newsList',
        config: 'contentConfig'
      }
    }else{
      this.pathObj={
        list: 'newsListIframe',
        config: 'contentConfig'
      }
    }
    this.activeKey = this.$route.path.includes('contentConfig') ?  'config':'list' 
    this.acKey = this.activeKey
  },
  methods: {
    handleSearch(){
      if(this.acKey=='list'){
        this.$refs.newsList.handleSearch()
      }else{
        this.$refs.contentConfig.handleSearch()
      }
    },
    handleChange(key) {
      this.acKey = key
      this.activeKey= key
      this.$router.push(this.pathObj[key])
    
    }
  }
}
</script>

<style lang="less" scoped>
.bulletin-container {
  background: #fff;
  padding: 8px 24px 0;
  :deep(.ant-tabs-bar) {
    margin-bottom: 0;
  }
}

.hide {
    display: none;
}
</style>
